/**
 * @generated SignedSource<<ac49a97fb686d657d33effe482d3f8c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FirstBookingUpdateConfirmationStatusForm_contract$data = {
  readonly firstBooking: {
    readonly bookingId: string;
  } | null;
  readonly firstBookingConfirmationStatus: {
    readonly reason: string;
  } | null;
  readonly " $fragmentType": "FirstBookingUpdateConfirmationStatusForm_contract";
};
export type FirstBookingUpdateConfirmationStatusForm_contract$key = {
  readonly " $data"?: FirstBookingUpdateConfirmationStatusForm_contract$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstBookingUpdateConfirmationStatusForm_contract">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FirstBookingUpdateConfirmationStatusForm_contract",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "isFirstBooking",
          "value": true
        }
      ],
      "concreteType": "Booking",
      "kind": "LinkedField",
      "name": "firstBooking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookingId",
          "storageKey": null
        }
      ],
      "storageKey": "firstBooking(isFirstBooking:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "firstBookingConfirmationStatus",
      "kind": "LinkedField",
      "name": "firstBookingConfirmationStatus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Contract",
  "abstractKey": null
};

(node as any).hash = "c83561c0b180af21e8ef3c70e5aee629";

export default node;
